export default function tracking() {
	navigationTracking("header", "header", "navigation_click");
	navigationTracking("footer", "footer", "navigation_click");
	cardBlockTracking();
	bannerTracking();
	newsContentTracking();
	newsfeedTracking();
	ninjaFormsTracking();

	function navigationTracking(selector, type, event) {
		document.querySelectorAll(selector + ' a')?.forEach(link => {
			link.addEventListener("click", (e) => {
				const text = link.textContent.trim();
				
				if (text) {
					window.dataLayer.push({
						event: event,
						text: text,
						type: type,
					});
				}
			});
		});
	};

	function cardBlockTracking() {
		const cards = document.querySelectorAll('.js-cards-tracking') || [];

		cards.forEach(cardBlock => {
			const link = cardBlock.querySelectorAll('a');
			if (!link) return;

			const heading = cardBlock.querySelector('h2')?.textContent.trim() || '';
			if (!heading) return;

			link.forEach(el => {
				el.addEventListener('click', (e) => {
					const button = el.querySelector('.btn');
					if (!button) return;
					const text = button.textContent.trim();

					if (text) {
						window.dataLayer.push({
							event: "cta_click",
							text: text,
							type: heading,
						});
					}
				});
			});
		});
	};

	function bannerTracking() {
		const banners = document.querySelectorAll('.js-banner-tracking') || [];
		
		banners.forEach(banner => {
			banner.addEventListener('click', (e) => {
				const button = banner.querySelector('.btn')?.textContent.trim() || '';

				if (button) {
					window.dataLayer.push({
						event: "cta_click",
						title: button,
						type: "carousel",
					});
				}
			});
		});
	};

	function newsContentTracking() {
		document.querySelectorAll('.js-shortcode-button')?.forEach(link => {
			link.addEventListener("click", (e) => {
				const text = link.textContent.trim();
				
				if (text) {
					window.dataLayer.push({
						event: "buy_button",
						text: text,
					});
				}
			});
		});
	};

	function newsfeedTracking() {
		const news = document.querySelectorAll(".js-newsfeed-news");
		const videos = document.querySelectorAll(".js-newsfeed-video");

		news.forEach(item => {
			item.addEventListener("click", (e) => {
				const title = item.querySelector("h2")?.textContent.trim() || "";

				window.dataLayer.push({
					event: "article_interaction",
					title: title,
				});
			});
		});

		videos.forEach(item => {
			item.addEventListener("click", (e) => {
				const title = item.querySelector("h2")?.textContent.trim() || "";

				window.dataLayer.push({
					event: "video_interaction",
					title: title,
				});
			});
		});
	};

	function ninjaFormsTracking() {
		if (typeof Marionette !== "undefined" && typeof nfRadio !== "undefined") {
			const submitChannel = nfRadio.channel("forms");
			submitChannel.on("submit:response", (response) => {
				const formId = response?.data?.form_id;

				// Form ID 2 = Newsletter
				if (formId == 2) {
					window.dataLayer.push({
						event: "newsletter_subscription",
						form_location: "keep updated",
					});
				}
			});
		}
	};
}
